<template>
  <div>
    <div class="col-md-12">
      <ValidationProvider
        name="documento"
        rules="required"
        v-slot="{ errors }"
        :custom-messages="{ required: 'El documento es obligatorio' }"
      >
        <b-form-group label="Documento:">
          <b-form-file
            v-model="currentDocumento.file"
            browse-text="Seleccionar"
            drop-placeholder="Cargar aquí"
            placeholder="Da click aquí o arrastra el archivo"
            :accept="acceptedFileTypes"
            @input="onInput"
          />
          <p class="orange-italic-13p-text" style="margin-top: 1rem" v-if="!isStaff">Tamaño máximo del archivo: 25 MB</p>
          <p class="orange-italic-13p-text" v-if="acceptedFileTypes === 'application/pdf'">
            Favor de subir archivos PDF (.pdf) únicamente.
          </p>
          <span class="cardErrors">{{ errors[0] }}</span>
        </b-form-group>
      </ValidationProvider>
    </div>

    <div class="mt-4 text-center">
      <button type="submit" class="btn btn-fill float-right orange-btn">Guardar</button>
    </div>
  </div>
</template>

<script>
import Storage from "@/utils/storage";

const storage = new Storage();

export default {
  name: "ModalEntregaDocumento",

  props: {
    currentDocumento: { type: Object },
    cotejo: { type: Object },
    acceptedFileTypes: {
      type: String,
      default: () => "application/pdf",
    },
  },

  created() {
    this.isStaff = storage.getItem("role").toLowerCase().includes("staff");
  },

  data() {
    return {
      isStaff: false,
    };
  },

  methods: {
    onInput(inputFile) {
      const acceptedFileTypesSplitted = this.acceptedFileTypes.split(",");

      if (!acceptedFileTypesSplitted.includes(inputFile.type)) {
        this.$toast.error("Tipo de archivo no aceptado.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        this.currentDocumento.file = null;
        return;
      }

      if (!this.isStaff && inputFile.size > 26214400) {
        this.$toast.error("El archivo que desea cargar no puede ser mayor a 25 MB, si es el caso, envíe un correo a info@correduriadigital.mx.", {
          timeout: 6000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        this.currentDocumento.file = null;
        return;
      }
    },
  },
};
</script>

<style scoped>
.control-label {
  position: absolute;
  display: inline-block;
  margin-left: 30px;
}

.custom-number {
  width: 100px !important;
  display: inline-block;
  margin-left: 30px;
}
</style>
